import { Translation } from '@ps/web-shared-components';
import React from 'react';

import Container from '../../../Container/Container';

import {
  TXTCLI_Citizenship,
  TXTWCL_We_will_ask_you_for_this_infor_ELL_1,
  TXTWCL_WhatXs_your_citizenshipX
} from './RMFCitizenship.messages.json';
import Fields from './components/Fields/Fields';

const RMFCitizenship: React.FC = () => (
  <Container
    page={RMFCitizenship}
    headerProps={{
      title: <Translation {...TXTCLI_Citizenship} />
    }}
    pageTopTitle={<Translation {...TXTWCL_WhatXs_your_citizenshipX} />}
    pageTopSubtitle={<Translation {...TXTWCL_We_will_ask_you_for_this_infor_ELL_1} />}
  >
    <Fields />
  </Container>
);

RMFCitizenship.displayName = 'RMFCitizenship';

export default RMFCitizenship;
